import { agentLoginByPassword } from './login-by-password.service'

export const agentLoginByPasswordOptions = () => ({
  queryKey: ['agent-login-by-password'],
  queryFn: agentLoginByPassword,
  enabled: false, // This is a mutation, not a query, so it should be disabled by default
})
